import { useAuthSessionTokens } from 'hooks/useAuthSession';
import { type IAuth } from 'services/authSession';

type AuthTokensQueryResult = {
  data: IAuth | null | undefined;
  isError: false;
  error: null;
  isLoading: false;
  isPending: false;
  isFetching: false;
};

export function useAuthTokens(): AuthTokensQueryResult {
  const tokens = useAuthSessionTokens();

  return {
    data: tokens,
    isError: false,
    error: null,
    isLoading: false,
    isPending: false,
    isFetching: false
  };
}
